/* eslint-disable import/prefer-default-export */
export const SET_PROGRESS_BAR_STATUS = 'SET_PROGRESS_BAR_STATUS';
